import { useParams } from "react-router-dom";
import Axios from "../../../utils/axios";
import { useEffect, useMemo, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import ButtonsCrud from "../../../components/Catalogs/ButtonsCrud";
import Input from "../../../components/Atomos/Inputs/Input";
import DropDownList from "../../../components/Atomos/DropDown/Dropdown";
import CloseModal from "../../../components/Atomos/Icons/EditMode/CloseModal";
import TextArea from "../../../components/Atomos/Inputs/TextArea";
import NewButton from "../../../components/Atomos/Buttons/newButton";
import GoBack from "../../../components/Moleculas/GoBack";
import CatalogSubTitle from "../../../components/Moleculas/Catalog Text/CatalogSubTitle";
import CatalogTitle from "../../../components/Moleculas/Catalog Text/CatalogTitle";
import RadioButton from "../../../components/Atomos/Radio/RadioButton";
import InputImage from "../../../components/Atomos/InputImage/InputImage";
import { PhoneNumber } from "../../../components/Atomos/PhoneNumber/PhoneNumber";
import Plus2 from "../../../components/Atomos/Icons/Plus";
import InputImageMinimal from "../../../components/Atomos/InputImage/InputImageMinimal";
import useViewport from "../../../hooks/useViewPort";
import Remove from "../../../components/Atomos/Icons/Remove";
import NewTooltip from "../../../components/Atomos/Tooltip/NewTooltip";
import SaveOverride from "../../../components/Catalogs/SaveOverride";
import { getCitiesByState } from "../../../Services/City";
import { UseCountryList } from "../../../hooks/Catalogs";
import { uploadImage } from "../../../utils/UploadImage";
import { useDispatch, useSelector } from "react-redux";
import { useStatesList } from "../../../hooks/Catalogs/useStates";
import { useCityList } from "../../../hooks/Catalogs/useCityList";
import { getCurrentTimestamp } from "../../../utils/functions";
import {
  createFirm,
  deleteFirm,
  updateFirm as updateFirmService,
} from "../../../Services/Firm";
import {
  AddFirm as AddFirmAction,
  DeleteFirm,
  UpdateFirm,
} from "../../../redux/catalogs/states";
import { ModifyContent } from "../../../redux/states";
import { getOfficeContactByFirmId, saveOfficeContact, updateOfficeContact } from "../../../Services/MemberMainContact";
import IFirm from "../../../interfaces/models/IFirm";
import {
  IAddress,
  initialValue as initialAddress,
} from "../../../interfaces/models/IAddress";
import { IState } from "../../../interfaces";
import { ServiceType } from "../../../Enums/FirmEnum";
import { Appstore, contentContext } from "../../../redux";
import {
  buildJurisdiction,
  formatJurisdiction,
  getJurisdictionLabel,
} from "../../../utils/jurisdiction/structuredJurisdiction";

interface iCatalogProps {
  mode: "add" | "edit";
  isMember?: boolean;
  isMemeberDisabled?: boolean | undefined;
}

const moment = require("moment");

let now = moment().format("DD/MM/YYYY");
interface ActiveErrors {
  address: boolean;
  city: boolean;
  country: boolean;
  firmOverview: boolean;
  inputAcceptedEmailDomain: boolean;
  inputFirmName: boolean;
  inputJurisdiction: boolean;
  inputMembershipType: boolean;
  inputName: boolean;
  inputOtherServiceType: boolean;
  inputPhoneNumber: boolean;
  inputServiceType: boolean;
  inputWebsiteUrl: boolean;
  logo: boolean;
  notable1: boolean;
  notable2: boolean;
  notable3: boolean;
  notable4: boolean;
  smallLogo: boolean;
  state: boolean;
}

const initialActiveErrors: ActiveErrors = {
  inputName: false,
  inputFirmName: false,
  inputServiceType: false,
  inputMembershipType: false,
  inputJurisdiction: false,
  inputOtherServiceType: false,
  inputPhoneNumber: false,
  inputWebsiteUrl: false,
  inputAcceptedEmailDomain: false,
  country: false,
  state: false,
  city: false,
  logo: false,
  smallLogo: false,
  firmOverview: false,
  address: false,
  notable1: false,
  notable2: false,
  notable3: false,
  notable4: false,
};

const ActiveErrorsMessage = {
  inputName: "The Name is required.",
  inputFirmName: "The Firm Legal Name is required.",
  inputServiceType: "The Service Type is required.",
  inputMembershipType: "The Membership Type is required.",
  inputJurisdiction:
    "The Jurisdiction is required. Select a country (and state for USA, Canada or China).",
  inputOtherServiceType: "The Service Type is required.",
  inputPhoneNumber: "The Phone Number is required.",
  inputWebsiteUrl: "The Website Url is required.",
  inputAcceptedEmailDomain: "The Accepted Email Domain is required.",
  country: "Country is required",
  state: "State is required",
  city: "City is required",
  address: "Address is required",
  notable: "Notable URL is required",
  logo: "Logo is required",
  smallLogo: "Small Logo is required",
  firmOverview: "Firm Overview is required",
};

interface IFormFirm extends Partial<IFirm> {
  notable1: string;
  notable2: string;
  notable3: string;
  notable4: string;
}

const initialFormData: IFormFirm = {
  name: "",
  firmName: "",
  shortId: undefined,
  hasSecondary: false,
  otherServiceType: "",
  phoneNumber: "",
  websiteUrl: "",
  dateCreated: now,
  dateJoined: undefined,
  dateWithdrawn: undefined,
  firmOverview: "",
  logo: "",
  smallLogo: "",
  professionalsInPrimary: undefined,
  professionalsWorldWide: undefined,
  totalProfessionals: undefined,
  acceptedEmailDomain: [],
  practiceIndustry: "",
  linkedinUrl: "",
  yearFounded: "",
  xUrl: "",
  facebookUrl: "",
  instagramUrl: "",
  youtubeUrl: "",
  otherSocialMedia: "",
  notable1: "",
  notable2: "",
  notable3: "",
  notable4: "",
  serviceType: undefined,
};

const AddFirm: React.FC<iCatalogProps> = (props) => {
  const { state } = useLocation();
  const axios = new Axios();
  const navigate = useNavigate();
  const { id } = useParams();
  const firmId = id ?? "";

  const [buttonClicked, setButtonClicked] = useState("");
  const [checked, setChecked] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [logo, setLogo] = useState<string | File | null>();
  const [smallLogo, setSmallLogo] = useState<string | File | null>();
  const [notableImage1, setNotableImage1] = useState<string | File | null>();
  const [notableImage2, setNotableImage2] = useState<string | File | null>();
  const [notableImage3, setNotableImage3] = useState<string | File | null>();
  const [notableImage4, setNotableImage4] = useState<string | File | null>();
  const [newEmailDomain, setNewEmailDomain] = useState("");

  const [cities, setCities] = useState<any[]>([]);
  const [addresses, setAddresses] = useState<any[]>([]);
  const [listingCategory, setListingCategory] = useState<any[]>([]);
  const [acceptedEmailDomain, setAcceptedEmailDomain] = useState<any[]>(
    state?.acceptedEmailDomain ?? [],
  );

  const [activeErrors, setActiveErrors] =
    useState<ActiveErrors>(initialActiveErrors);
  const [activeErrorsMessage, setActiveErrorsMessage] =
    useState(ActiveErrorsMessage);
  const [canSave, setCanSave] = useState(true);

  const [formData, setFormData] = useState<IFormFirm>(initialFormData);

  const [selectedServiceType, setSelectedServiceType] = useState("");
  const [selectedMembershipType, setSelectedMembershipType] = useState("");
  const [selectedMembershipStatus, setSelectedMembershipStatus] =
    useState("Onboarding");
  const [selectedCountry, setSelectedCountry] = useState({ id: "", name: "" });
  const [selectedState, setSelectedState] = useState({ id: "", name: "" });
  const [selectedCity, setSelectedCity] = useState({ id: "", name: "" });
  const [selectedAddress, setSelectedAddress] =
    useState<IAddress>(initialAddress);
  const [contactStructure, setContactStructure] = useState("firmWide");
  const [directPhoneCode, setDirectPhoneCode] = useState<{
    code: string;
    phone: string;
    basecode: string;
  }>({ code: "(+1)", phone: "", basecode: "USA" });
  const [isContentRedirect] = useState(!!state?.contentRedirectUrl);

  const [isMember, setIsMember] = useState(state?.isMember ?? true);
  const [saveOverrideOpen, setSaveOverrideOpen] = useState(false);
  const [errorFields, setErrorFields] = useState<string[]>([]);
  const [statesByCity, setStatesByCity] = useState<IState[]>([]);

  const dispatch = useDispatch();
  const { countryData: countries } = UseCountryList();
  const { statesData } = useStatesList();
  const { cityData } = useCityList();
  const [serviceTypes] = useState<{ id: string; name: string }[]>(
    Object.entries(ServiceType).map(([key, value]) => ({
      id: key,
      name: String(value),
    })),
  );
  const currentContent: contentContext = useSelector(
    (store: Appstore) => store.content,
  );

  useEffect(() => {
    if (!countries.length || !cityData.length || !statesData.length) {
      return;
    }
    setData();
  }, [state, countries, cityData, statesData]);

  const setData = () => {
    if (state) {
      setFormData({ ...state });
      setIsMember(state.isMember);
      setLogo(state?.logo?.length ? state.logo : null);
      setSmallLogo(state?.smallLogo?.length ? state.smallLogo : null);
      setSelectedServiceType(state?.serviceType ?? "");
      setSelectedMembershipStatus(state?.membershipStatus ?? "");
      setSelectedMembershipType(state?.membershipType ?? "");

      if (state.isMember) {
        const firmCity = cityData.find((c) => c.id === state?.cityId);
        const firmState = statesData.find((s) => s.id === state?.state);
        const firmCountry = countries.find((c) => c.id === state?.country);

        if (firmCountry) {
          setSelectedCountry(firmCountry);
        }
        if (firmState) {
          setSelectedState(firmState);
        }
        setSelectedCity({ id: firmCity?.id ?? "", name: firmCity?.name ?? "" });
        if (state.phoneNumber) {
          setDirectPhoneCode(state.phoneNumber);
        }
      } else {
        const firmCountry = countries.find((c) => c.id === state?.country);
        const firmState = statesData.find((s) => s.id === state?.state);
        if (firmCountry) {
          setSelectedCountry(firmCountry);
        }
        if (firmState) {
          setSelectedState(firmState);
        }
      }
    }
  };

  const firmJurisdiction = useMemo(
    () =>
      buildJurisdiction(
        {
          countryName: selectedCountry.name,
          stateName: selectedState.name,
          stateAbbreviation: statesData.find((s) => s.id === selectedState.id)
            ?.abbreviation,
        },
        "firm",
      ),
    [selectedCountry.name, selectedState.id, selectedState.name, statesData],
  );

  const jurisdictionPreview = firmJurisdiction
    ? formatJurisdiction(firmJurisdiction)
    : getJurisdictionLabel(state);

  useEffect(() => {
    if (!countries.length || !selectedCountry) {
      return;
    }
    const currentCountry = countries.find((c) => c.id === selectedCountry.id);
    setFormData((prevState) => ({
      ...prevState,
      region: currentCountry?.regions.map((r: any) => r.id),
      regionNames: currentCountry?.regionNames,
    }));
    setStatesByCity(statesData.filter((s) => s.country === selectedCountry.id));
  }, [selectedCountry, countries]);

  useEffect(() => {
    if (!selectedState?.id) {
      return;
    }
    getCitiesByState(selectedState.id).then((data) => setCities(data));
  }, [selectedState]);

  useEffect(() => {
    if (!selectedCity.id) {
      return;
    }
    fetchAddresses();
  }, [selectedCity]);

  const fetchAddresses = async () => {
    try {
      const cityAux = cities
        .filter((c) => c.name === selectedCity.name)
        .map((c) => c.id);
      const response = await axios.Get(
        "./address?cities=" + JSON.stringify(cityAux),
      );

      const data = response.data.map((a: any) => {
        a.name = a.address1;
        return a;
      });

      if (state?.address) {
        if (Array.isArray(state.address) && state.address.length > 0) {
          const firstAddress = state.address[0];
          const firmAddres = data.find(
            (a: any) =>
              a.city === firstAddress.city &&
              a.address1 === firstAddress.address1,
          );
          if (firmAddres) {
            setSelectedAddress(firmAddres);
          }
        } else if (typeof state.address === "string") {
          const firmAddres = data.find((a: any) => a.id === state.address);
          if (firmAddres) {
            setSelectedAddress(firmAddres);
          }
        }
      }

      if (data != null) {
        const newAddresses = data.filter(
          (item: any) => item.city === selectedCity.id,
        );
        setAddresses(newAddresses);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  const isSomeError = (activeErrors: ActiveErrors): boolean => {
    for (const key in activeErrors) {
      if (activeErrors[key as keyof ActiveErrors] === true) {
        return true;
      }
    }
    return false;
  };

  const handleDelete = async (id: string) => {
    try {
      await deleteFirm(state.id);
      dispatch(DeleteFirm(state.id));
      navigate(-1);
    } catch (error) {
      console.error(error);
    }
  };

  const handleButtonClick = (buttonName: string) => {
    setButtonClicked(buttonName);
  };

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    if (!checked) {
      setChecked(true);
    }
    if (buttonClicked !== "saveOverride") {
      if (validateForm()) {
        return;
      }
    }

    if (!state?.logo?.length || (state?.logo?.length && state?.logo === logo)) {
      handleSave(logo as string);
    } else {
      try {
        await uploadImage(logo as File, firmId, "firm/logos/")
          .then((response) => {
            if (response) {
              setLogo(response as string);
              handleSave(response as string);
            } else {
              console.error("No response received from uploadImage.");
            }
          })
          .catch((error) => {
            console.error("Error during image upload:", error);
          });
      } catch (error) {
        // Handle unexpected errors
        console.error("Unexpected error during image upload:", error);
      }
    }
  };

  const handleInputChange = (
    event: React.ChangeEvent<
      HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement
    >,
  ) => {
    const { name, value } = event.target;
    if (name === "yearFounded") {
      const yearPattern = /^\d{0,4}$/;
      if (value === "" || (yearPattern.test(value) && value.length <= 4)) {
        setFormData((prevData) => ({
          ...prevData,
          [name]: value,
        }));
      }
    } else {
      setFormData((prevData) => ({
        ...prevData,
        [name]: value,
      }));
    }
  };

  const handleDropDownCountry = (obj: any) => {
    setSelectedCountry({ id: obj.id, name: obj.name });
    setSelectedState({ id: "", name: "" });
    setSelectedCity({ id: "", name: "" });
    setSelectedAddress(initialAddress);
  };
  const handleDropDownState = (obj: any) => {
    setSelectedState({ id: obj.id, name: obj.name });
    setSelectedCity({ id: "", name: "" });
    setSelectedAddress(initialAddress);
  };
  const handleDropDownCity = (obj: any) => {
    setSelectedCity({ id: obj.id, name: obj.name });
    setSelectedAddress(initialAddress);
  };
  const handleDropDownAddress = (obj: any) => {
    setSelectedAddress(obj as IAddress);
  };

  useEffect(() => {
    if (checked) {
      validateForm();
    }
  }, [
    formData,
    logo,
    smallLogo,
    directPhoneCode,
    selectedMembershipStatus,
    selectedServiceType,
    selectedMembershipType,
    selectedCountry,
    selectedState,
    selectedCity,
    selectedAddress,
    acceptedEmailDomain,
  ]);

  const validateForm = () => {
    let newActiveErrors;
    if (isMember) {
      const jurisdictionInput = !firmJurisdiction && selectedServiceType !== "";
      const nameInput = formData.name === "";
      const firmNameInput = formData.firmName === "";
      const serviceTypeInput = selectedServiceType === "";
      const membershipTypeInput = selectedMembershipType === "";
      const otherServiceTypeInput =
        selectedServiceType === "Other" && formData.otherServiceType === "";
      const phoneNumberInput = directPhoneCode.phone === "";
      const websiteUrlInput = formData.websiteUrl === "";

      newActiveErrors = {
        inputName: nameInput,
        inputFirmName: firmNameInput,
        inputServiceType: serviceTypeInput,
        inputMembershipType: membershipTypeInput,
        inputJurisdiction: jurisdictionInput,
        inputOtherServiceType: otherServiceTypeInput,
        inputPhoneNumber: phoneNumberInput,
        inputWebsiteUrl: websiteUrlInput,
        inputAcceptedEmailDomain: !acceptedEmailDomain.length,
        country: selectedCountry?.id === "",
        state: statesByCity.length > 0 && selectedState?.id === "",
        city: cities.length > 0 && selectedCity.id === "",
        address: selectedAddress.id === "",
        logo: logo === null,
        smallLogo: smallLogo === null,
        firmOverview: formData.firmOverview === "",
        notable1: !!(notableImage1 && formData.notable1),
        notable2: !!(notableImage2 && formData.notable2),
        notable3: !!(notableImage3 && formData.notable3),
        notable4: !!(notableImage4 && formData.notable4),
      };
    } else {
      const nameInput = formData.name === "";
      const firmNameInput = formData.firmName === "";

      newActiveErrors = {
        inputName: nameInput,
        inputFirmName: firmNameInput,
        inputServiceType: false,
        inputMembershipType: false,
        inputJurisdiction: false,
        inputOtherServiceType: false,
        inputPhoneNumber: false,
        inputWebsiteUrl: false,
        inputAcceptedEmailDomain: false,
        country: selectedCountry?.id === "",
        state: false,
        city: false,
        address: false,
        notable1: false,
        notable2: false,
        notable3: false,
        notable4: false,
        logo: logo === null,
        smallLogo: false,
        firmOverview: false,
      };
    }
    setActiveErrors(newActiveErrors);
    return isSomeError(newActiveErrors);
  };

  const handleDropDownMembershipType = (name: string) => {
    setSelectedMembershipType(name);
    if (name === "Primary") {
      setContactStructure("firmWide");
    }
  };

  const handleDropDownMembershipStatus = (name: string) => {
    setSelectedMembershipStatus(name);
  };

  const handleDropDownServiceType = (name: string) => {
    setSelectedServiceType(name);
    if (name !== "Other") {
      formData.otherServiceType = "";
    }
  };

  const handleChangeListingCategory = (id: number, value: any) => {
    setListingCategory(listingCategory.splice(id, 0, value.target.value));
  };

  const deleteEmailDomain = (name: string) => {
    setAcceptedEmailDomain(
      acceptedEmailDomain.filter((email) => email != name),
    );
  };

  const handleSave = async (logo: string) => {
    try {
      const firm = buildFirmObject(logo);
      const response = await (props.mode === "add"
        ? saveFirm(firm)
        : updateFirm({ ...firm, id: state.id }));
      if (firm.name) {
        await handlePost(response.id, firm.name);
      }
      if (!!state?.contentRedirectUrl) {
        navigate(state.contentRedirectUrl);
        dispatch(
          ModifyContent({
            content: {
              ...currentContent,
              nonMemberFirms: response.id,
            },
          }),
        );
      } else {
        navigate(-1);
      }
    } catch (error: any) {
      console.error(error);
    }
  };

  const buildFirmObject = (logo?: string) => {
    const commonFields = {
      isMember,
      name: formData?.name,
      firmName: formData.firmName,
      shortId: formData.shortId,
      legacyId: formData.legacyId,
      serviceType: selectedServiceType,
      linkedinUrl: formData.linkedinUrl,
      xUrl: formData.xUrl,
      instagramUrl: formData.instagramUrl,
      facebookUrl: formData.facebookUrl,
      youtubeUrl: formData.youtubeUrl,
      otherSocialMedia: formData.otherSocialMedia,
      logo: logo,
      country: selectedCountry?.id,
      countryName: selectedCountry?.name,
      region: formData.region,
      regionNames: formData.regionNames,
      state: selectedState?.id,
      stateName: selectedState?.name,
      dateCreated: formData.dateCreated,
    };

    return isMember
      ? {
          ...commonFields,
          firmName: formData.firmName,
          shortId: formData.shortId,
          serviceType: selectedServiceType,
          otherServiceType: formData.otherServiceType,
          membershipStatus: selectedMembershipStatus,
          membershipType: selectedMembershipType,
          jurisdiction: firmJurisdiction ?? state?.jurisdiction,
          phoneNumber: directPhoneCode,
          websiteUrl: formData.websiteUrl,
          yearFounded: formData.yearFounded,
          acceptedEmailDomain: acceptedEmailDomain,
          listingCategory: listingCategory,
          notables: [
            { link: formData.notable1, photo: notableImage1 },
            { link: formData.notable2, photo: notableImage2 },
            { link: formData.notable3, photo: notableImage3 },
            { link: formData.notable4, photo: notableImage4 },
          ],
          firmOverview: formData.firmOverview,
          professionalsInPrimary: formData.professionalsInPrimary,
          professionalsWorldWide: formData.professionalsWorldWide,
          totalProfessionals: formData.totalProfessionals,
          dateWithdrawn: formData.dateWithdrawn,
          cityId: selectedCity.id,
          cityName: selectedCity.name,
          address: selectedAddress.id
            ? [
                {
                  address1: selectedAddress.address1,
                  address2: selectedAddress.address2 || "",
                  city: selectedCity.name,
                  country: selectedCountry?.name || "",
                  zipCode:
                    typeof selectedAddress.zipCode === "string"
                      ? selectedAddress.zipCode
                      : String(selectedAddress.zipCode ?? ""),
                  state: selectedState?.name || undefined,
                },
              ]
            : undefined,
          smallLogo: smallLogo,
        }
      : {
          ...commonFields,
          phoneNumber: false,
        };
  };

  const updateFirm = async (firm: any) => {
    try {
      const response = await updateFirmService(firm);
      dispatch(UpdateFirm(firm));
      return response;
    } catch (error: any) {
      console.error(error);
      throw error;
    }
  };

  const saveFirm = async (firm: any) => {
    try {
      const response = await createFirm({
        ...firm,
        dateCreated: getCurrentTimestamp(),
      });
      dispatch(AddFirmAction(response));
      return response;
    } catch (error) {
      console.error(error);
      handleSaveErrors(error);
      throw error;
    }
  };

  const handleSaveErrors = (error: any) => {
    if (error) {
      const hasDuplicateName = error.message.includes("shortId");
      if (hasDuplicateName) {
        setActiveErrorsMessage((prevState) => ({
          ...prevState,
          inputShortId: "This Number ID is duplicated.",
        }));
        setActiveErrors((prevState) => ({
          ...prevState,
          inputShortId: true,
        }));
      }
    }
  };

  const handlePost = async (firmId: string, firmName: string) => {
    try {
      const officeContact = {
        id: "",
        firm: firmId,
        firmName,
        createdAt: new Date(),
      };
      let response;
      if (props.mode === "add") {
        response = await Promise.all([
          saveOfficeContact(officeContact),
        ]);
      } else {
        const [_officeContact] = await Promise.all([
          getOfficeContactByFirmId(firmId),
        ]);
        officeContact.createdAt = _officeContact.createdAt;
        response = await Promise.all([
          updateOfficeContact(officeContact),
        ]);
      }
      return response;
    } catch (error: any) {
      console.error("Error saving contact information", error);
      throw error;
    }
  };

  const handleCloseSaveOverride = () => {
    setSaveOverrideOpen(!saveOverrideOpen);
  };

  useEffect(() => {
    const errorsToSet = Object.keys(activeErrors).filter(
      (clave) => activeErrors[clave as keyof typeof activeErrors],
    );
    setErrorFields(errorsToSet);
    setSaveOverrideOpen(errorsToSet.length > 0);

    setCanSave(!isSomeError(activeErrors));
  }, [activeErrors]);

  const { viewportWidth } = useViewport();

  return (
    <>
      {/* AQUI EMPIEZA EL MODAL */}
      {isModalOpen && (
        <div className="modal w-full h-screen fixed flex justify-center items-center z-20">
          <div
            className="w-full h-full absolute bg-black opacity-80"
            onClick={() => setIsModalOpen(false)}
          ></div>
          <div className="flex flex-col justify-center items-center text-3xl text-white z-30 relative">
            <div className="modal-content bg-white p-[1.5rem] lg:w-[40rem] w-full max-h-[70vh] overflow-y-auto">
              <div className="flex items-center justify-between pb-[1.5rem]">
                <h1 className="text-primary text-left text-[2rem] font-bold">
                  Upload Profile Image
                </h1>
                <div
                  className="w-max cursor-pointer"
                  onClick={() => setIsModalOpen(false)}
                >
                  <CloseModal />
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
      {/*  */}
      <main className={`${saveOverrideOpen ? "pt-7 md:pt-9 " : ""}`}>
        <form onSubmit={handleSubmit}>
          <SaveOverride
            fields={errorFields}
            handleButtonClick={handleButtonClick}
            open={saveOverrideOpen}
            close={handleCloseSaveOverride}
          />
          <CatalogTitle
            title={`${
              props.mode === "add"
                ? "New Firm"
                : `Edit ${state ? state?.name : ""}`
            }`}
            className="text-Default"
          >
            <GoBack />
          </CatalogTitle>
          <article className="articleSection">
            {!isMember && (
              <section className="formsectionNTitle">
                <CatalogSubTitle
                  title="Primary Information"
                  className="text-accent-Default-dark"
                />
                <div className="flex flex-col w-full formsection">
                  <div className="flex flex-col md:flex-row formsection w-full">
                    <span className="text-[1rem] lg:text-[1.375rem] lg:font-bold leading-[1.125rem] lg:leading-6 not-italic text-gray-font">
                      {" "}
                      Firm Type:{" "}
                    </span>
                    <div className="flex flex-row formsection">
                      <RadioButton
                        index={0}
                        text={"Member"}
                        selected={isMember}
                        handleRadioButtonChange={() => setIsMember(true)}
                        name="typeSelection"
                        disabled={isContentRedirect}
                      />
                      <RadioButton
                        index={1}
                        text={"Non-Member"}
                        selected={!isMember}
                        handleRadioButtonChange={() => setIsMember(false)}
                        name="typeSelection"
                      />
                    </div>
                  </div>
                  <div className="flex w-full formsection md:pb-5 flex-wrap lg:flex-nowrap">
                    <div className="flex flex-col md:flex-row w-full formsection lg:w-4/5">
                      <div className="flex flex-col w-full md:w-1/2 lg:w-1/2">
                        <Input
                          title="Firm Legal Name"
                          name="firmName"
                          errorMsj={activeErrorsMessage.inputFirmName}
                          error={activeErrors.inputFirmName}
                          value={formData?.firmName}
                          onChange={handleInputChange}
                          required={!isMember}
                        />
                      </div>
                      <div className="flex flex-col w-full md:w-1/2 lg:w-1/2 ">
                        <Input
                          title="Name"
                          name="name"
                          errorMsj={activeErrorsMessage.inputName}
                          error={activeErrors.inputName}
                          value={formData?.name}
                          onChange={handleInputChange}
                          required={!isMember}
                        />
                      </div>
                    </div>
                    <div className="flex flex-col md:flex-row w-full formsection lg:w-1/5 ">
                      <div className="flex flex-col w-full md:w-1/2 lg:w-full">
                        <Input
                          title="Number ID"
                          name="shortId"
                          errorMsj={""}
                          error={false}
                          value={formData?.shortId?.toString()}
                          required={false}
                          disabled
                        />
                      </div>
                    </div>
                  </div>
                  <div className="flex flex-col md:flex-row formsection w-full">
                    <div
                      className={`w-full  md:w-[8rem] lg:mr-4 lg:w-40 xl:w-[15rem] `}
                    >
                      <InputImage
                        required={!isMember}
                        setImage={setLogo}
                        photo={logo as string}
                        maxsize={25}
                        width={300}
                        height={300}
                        title="Logo"
                        error={activeErrors.logo}
                        errorMsg={activeErrorsMessage.logo}
                      />
                    </div>
                    <div className="grid formsection w-full grid-cols-6 lg:h-[50%]">
                      <div className="flex flex-col w-full col-span-6 lg:col-span-2">
                        <DropDownList
                          title="ServiceType"
                          selectedObjst={selectedServiceType}
                          seter={handleDropDownServiceType}
                          data={serviceTypes}
                          error={activeErrors.inputServiceType}
                          errormsj={activeErrorsMessage.inputServiceType}
                          required={isMember}
                        />
                      </div>
                      <div className="flex flex-col w-full col-span-6 lg:col-span-2">
                        <DropDownList
                          title="Country"
                          selectedObjst={selectedCountry?.name}
                          seter={handleDropDownCountry}
                          data={countries}
                          error={activeErrors.country}
                          errormsj={activeErrorsMessage.country}
                          required={!isMember}
                          getid
                        />
                      </div>
                      {statesByCity.length > 0 ? (
                        <div className="flex flex-col w-full col-span-6 lg:col-span-2">
                          <DropDownList
                            title="State"
                            disabled={selectedCountry?.id === ""}
                            selectedObjst={selectedState?.name}
                            seter={handleDropDownState}
                            data={statesByCity}
                            error={activeErrors.state}
                            errormsj={activeErrorsMessage.state}
                            getid
                          />
                        </div>
                      ) : null}
                      <div className="lg:col-span-3 col-span-6">
                        <PhoneNumber
                          title={"Phone Number"}
                          Obj={directPhoneCode}
                          seter={setDirectPhoneCode}
                          error={activeErrors.inputPhoneNumber}
                          errormsj={activeErrorsMessage.inputPhoneNumber}
                          required={isMember}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </section>
            )}
            {isMember && (
              <section className="formsectionNTitle">
                <CatalogSubTitle
                  title="Firm Primary Information"
                  className="text-accent-Default-dark"
                />
                <div className=" w-full flex flex-col formsection">
                  <div className="flex flex-col md:flex-row formsection">
                    <span className="text-[1rem] lg:text-[1.375rem] lg:font-bold leading-[1.125rem] lg:leading-6 not-italic text-gray-font ">
                      {" "}
                      Firm Type:{" "}
                    </span>
                    <div className="flex flex-row formsection">
                      <RadioButton
                        index={0}
                        text={"Member"}
                        selected={isMember}
                        handleRadioButtonChange={() => setIsMember(true)}
                        name="typeSelection"
                      />
                      <RadioButton
                        index={1}
                        text={"Non-Member"}
                        selected={!isMember}
                        handleRadioButtonChange={() => setIsMember(false)}
                        name="typeSelection"
                      />
                    </div>
                  </div>

                  <div className="grid grid-cols-12 formsection">
                    <div className="flex flex-col w-full col-span-12 md:col-span-6 lg:col-span-5">
                      <Input
                        title="Firm Legal Name"
                        name="firmName"
                        errorMsj={activeErrorsMessage.inputFirmName}
                        error={activeErrors.inputFirmName}
                        value={formData?.firmName}
                        onChange={handleInputChange}
                        required={isMember}
                      />
                    </div>
                    <div className="flex flex-col w-full col-span-12 md:col-span-6 lg:col-span-5 ">
                      <Input
                        title="Name"
                        name="name"
                        errorMsj={activeErrorsMessage.inputName}
                        error={activeErrors.inputName}
                        value={formData?.name}
                        onChange={handleInputChange}
                        required={isMember}
                      />
                    </div>
                    <div className="flex flex-col w-full col-span-12 md:col-span-6 lg:col-span-2">
                      <Input
                        title="Number ID"
                        name="shortId"
                        errorMsj={""}
                        error={false}
                        value={formData?.shortId?.toString()}
                        required={isMember}
                        disabled
                      />
                    </div>

                    <div className="flex flex-col col-span-12 md:col-span-6 lg:col-span-4">
                      <DropDownList
                        title="ServiceType"
                        selectedObjst={selectedServiceType}
                        seter={handleDropDownServiceType}
                        data={serviceTypes}
                        error={activeErrors.inputServiceType}
                        errormsj={activeErrorsMessage.inputServiceType}
                        required={isMember}
                      />
                    </div>
                    <div className="flex flex-col col-span-12 md:col-span-6 lg:col-span-4">
                      <Input
                        title="Other Service Type"
                        name="otherServiceType"
                        required={isMember && selectedServiceType === "Other"}
                        disabled={selectedServiceType !== "Other"}
                        errorMsj={activeErrorsMessage.inputOtherServiceType}
                        error={activeErrors.inputOtherServiceType}
                        value={formData?.otherServiceType}
                        onChange={handleInputChange}
                      />
                    </div>
                    <div className="flex flex-col col-span-12 md:col-span-6 lg:col-span-4">
                      <DropDownList
                        title="Membership Status"
                        selectedObjst={selectedMembershipStatus}
                        seter={handleDropDownMembershipStatus}
                        data={[{ id: "Onboarding", name: "Onboarding" }]}
                        error={false}
                        errormsj={activeErrorsMessage.inputName}
                        disabled={true}
                        required={isMember}
                      />
                    </div>

                    <div className="flex flex-col col-span-12 md:col-span-6 lg:col-span-4">
                      <DropDownList
                        title="Membership Type"
                        selectedObjst={selectedMembershipType}
                        seter={handleDropDownMembershipType}
                        data={[
                          { id: "Primary", name: "Primary" },
                          { id: "Regional", name: "Regional" },
                          { id: "Multiple", name: "Multiple Primary" },
                        ]}
                        error={activeErrors.inputMembershipType}
                        errormsj={activeErrorsMessage.inputMembershipType}
                        required={true}
                      />
                    </div>
                    <div className="flex flex-col col-span-12 md:col-span-6 lg:col-span-4">
                      <Input
                        title="Jurisdiction"
                        name="jurisdiction"
                        required={isMember && selectedServiceType !== ""}
                        disabled
                        error={activeErrors.inputJurisdiction}
                        errorMsj={activeErrorsMessage.inputJurisdiction}
                        value={jurisdictionPreview}
                      />
                    </div>
                  </div>
                </div>
              </section>
            )}
            {isMember && (
              <section className="formsectionNTitle">
                <CatalogSubTitle
                  title="Firm Legal Address"
                  className="text-accent-Default-dark"
                />
                <div className="grid formsection w-full lg:grid-cols-4 md:grid-cols-2">
                  <div className="flex flex-col w-full md:1/2">
                    <DropDownList
                      title="Country"
                      selectedObjst={selectedCountry?.name}
                      seter={handleDropDownCountry}
                      data={countries}
                      error={activeErrors.country}
                      errormsj={activeErrorsMessage.country}
                      required={isMember}
                      getid
                    />
                  </div>
                  {statesByCity.length > 0 ? (
                    <div className="flex flex-col w-full md:1/2">
                      <DropDownList
                        title="State"
                        disabled={selectedCountry?.id === ""}
                        selectedObjst={selectedState?.name}
                        seter={handleDropDownState}
                        data={statesByCity}
                        error={activeErrors.state}
                        errormsj={activeErrorsMessage.state}
                        tooltip="Please select a Country."
                        getid
                        required={isMember}
                      />
                    </div>
                  ) : null}
                  {cities.length > 0 ? (
                    <div className="flex flex-col w-full md:1/2">
                      <DropDownList
                        title="City"
                        disabled={
                          selectedCountry?.id === "" || selectedState?.id === ""
                        }
                        selectedObjst={selectedCity.name}
                        seter={handleDropDownCity}
                        data={cities}
                        error={activeErrors.city}
                        errormsj={activeErrorsMessage.city}
                        tooltip="Please select a State."
                        getid
                        required={isMember}
                      />
                    </div>
                  ) : null}
                  <div className="flex flex-col w-full md:1/2">
                    <DropDownList
                      title="Address"
                      disabled={
                        selectedCountry?.id === "" ||
                        selectedState?.id === "" ||
                        selectedCity.id === ""
                      }
                      selectedObjst={selectedAddress.address1 || ""}
                      seter={handleDropDownAddress}
                      data={addresses}
                      error={activeErrors.address}
                      errormsj={activeErrorsMessage.address}
                      required={isMember}
                      tooltip="Please select a City."
                      getid
                    />
                  </div>
                </div>
              </section>
            )}
            {isMember && (
              <section className="formsectionNTitle">
                <CatalogSubTitle
                  title="Firm Additional Information"
                  className="text-accent-Default-dark"
                />
                <div className="w-full flex flex-col formsection">
                  <div className="flex formsection w-full flex-col lg:flex-row">
                    <div className="flex formsection items-center md:justify-around w-full flex-col md:flex-row">
                      <InputImage
                        required={isMember}
                        setImage={setLogo}
                        photo={logo as string}
                        maxsize={25}
                        width={300}
                        height={300}
                        title="Logo"
                        error={activeErrors.logo}
                        errorMsg={activeErrorsMessage.logo}
                      />
                      <InputImage
                        required={isMember}
                        setImage={setSmallLogo}
                        photo={smallLogo as string}
                        maxsize={25}
                        width={300}
                        height={300}
                        title="Small Logo"
                        error={activeErrors.smallLogo}
                        errorMsg={activeErrorsMessage.smallLogo}
                      />
                    </div>

                    <div className="grid grid-cols-1 lg:grid-cols-1 md:grid-cols-2 formsection w-full">
                      <div>
                        <PhoneNumber
                          title={"Phone Number"}
                          Obj={directPhoneCode}
                          seter={setDirectPhoneCode}
                          error={activeErrors.inputPhoneNumber}
                          errormsj={activeErrorsMessage.inputPhoneNumber}
                          required={isMember}
                        />
                      </div>
                      <div>
                        <Input
                          title="Website Url"
                          name="websiteUrl"
                          errorMsj={activeErrorsMessage.inputWebsiteUrl}
                          error={activeErrors.inputWebsiteUrl}
                          value={formData?.websiteUrl}
                          onChange={handleInputChange}
                          required={isMember}
                        />
                      </div>
                      <div>
                        <Input
                          title="Year Founded"
                          name="yearFounded"
                          error={false}
                          value={formData?.yearFounded}
                          placeholder="YYYY"
                          onChange={handleInputChange}
                        />
                      </div>
                      <div className="flex formsection flex-col md:col-span-2 lg:col-span-1">
                        <div className="flex formsection">
                          <Input
                            title="Accepted Email Domain"
                            name="acceptedEmailDomain"
                            errorMsj={
                              activeErrorsMessage.inputAcceptedEmailDomain
                            }
                            error={activeErrors.inputAcceptedEmailDomain}
                            value={newEmailDomain}
                            onChange={(e) => setNewEmailDomain(e.target.value)}
                            required={
                              isMember && acceptedEmailDomain.length <= 0
                            }
                          />

                          {viewportWidth > 768 && (
                            <div className="flex flex-col gap-2.5">
                              <span className="h-[1.2rem]"></span>
                              <div className="flex h-[3rem] ">
                                <NewButton
                                  text="Add"
                                  color="accent"
                                  onClick={() => {
                                    setAcceptedEmailDomain([
                                      ...acceptedEmailDomain,
                                      newEmailDomain,
                                    ]);
                                    setNewEmailDomain("");
                                  }}
                                  content="textIcon"
                                  size="small"
                                  style="filled"
                                  icon={<Plus2 />}
                                />
                              </div>
                            </div>
                          )}
                        </div>

                        {acceptedEmailDomain.map((domain) => {
                          return (
                            <div className="flex formsection items-end">
                              <Input
                                title=""
                                name="acceptedEmailDomain"
                                error={false}
                                value={domain}
                              />
                              <div className="flex h-[3rem]">
                                <NewButton
                                  text={viewportWidth > 768 ? "Remove" : ""}
                                  color="delete"
                                  onClick={() => deleteEmailDomain(domain)}
                                  content={
                                    viewportWidth > 768
                                      ? "textIcon"
                                      : "iconSquare"
                                  }
                                  size="large"
                                  style="outlined"
                                  icon={<Remove />}
                                />
                              </div>
                            </div>
                          );
                        })}
                        {viewportWidth < 768 && (
                          <div className="flex  w-full">
                            <NewButton
                              text="Add"
                              color="accent"
                              onClick={() => {
                                setAcceptedEmailDomain([
                                  ...acceptedEmailDomain,
                                  formData.acceptedEmailDomain,
                                ]);
                                setFormData((prevState) => ({
                                  ...prevState,
                                  acceptedEmailDomain: [],
                                }));
                              }}
                              content="textIcon"
                              size="large"
                              style="filled"
                              icon={<Plus2 />}
                            />
                          </div>
                        )}
                      </div>
                    </div>
                  </div>

                  <div className="w-full">
                    <TextArea
                      title="Firm Overview"
                      name="firmOverview"
                      error={activeErrors.firmOverview}
                      errorMsj={activeErrorsMessage.firmOverview}
                      value={formData?.firmOverview}
                      onChange={handleInputChange}
                      maxChars={3500}
                      characterCount={true}
                      required={isMember}
                    />
                  </div>

                  <div className="flex flex-col lg:flex-row formsection">
                    <span className="text-[1.125rem] leading-5 lg:leading-8 text-4 lg:text-[1.125rem]  not-italic text-accentDefault">
                      Firm Contact Structure:
                    </span>
                    <div className="flex flex-col md:flex-row formsection">
                      <RadioButton
                        index={0}
                        text={"Contacts defined Firm Wide"}
                        selected={contactStructure === "firmWide"}
                        handleRadioButtonChange={() =>
                          setContactStructure("firmWide")
                        }
                        name="typeSelection"
                        disabled={selectedMembershipType === "Primary"}
                      />
                      <RadioButton
                        index={1}
                        text={"Contacts defined by Membership Locations"}
                        selected={contactStructure === "membershipLocation"}
                        handleRadioButtonChange={() =>
                          setContactStructure("membershipLocation")
                        }
                        name="typeSelection"
                        disabled={selectedMembershipType === "Primary"}
                      />
                    </div>
                  </div>
                  <div className=" formsection">
                    <div className="pb-[.625rem]">
                      <span className="leading-[1.125rem] lg:leading-5 text-gray-font text-[1.125rem]">
                        Listing Category
                      </span>
                    </div>
                    <p className="text-gray-font leading-6 lg:leading-8">
                      Professionals representing your firm will be displayed
                      with 4 distinct titles in your firm's profile. Default
                      labels are "Partners", "Associates", "Of Counsel" and
                      "Other". To better fit the structure of your firm. Fill in
                      the desired titles in the boxes below which will be
                      available when "Other" is selected.
                    </p>
                    <div className="grid grid-cols-1  grid-rows-2 md:grid-cols-2 formsection">
                      <TextArea
                        title=""
                        maxChars={50}
                        height="h-[50px]"
                        characterCount={true}
                        name="listingCategory1"
                        error={false}
                        value={listingCategory[0]}
                        onChange={(value) =>
                          handleChangeListingCategory(0, value)
                        }
                        required={false}
                      />
                      <TextArea
                        title=""
                        maxChars={50}
                        height="h-[50px]"
                        characterCount={true}
                        name="listingCategory2"
                        error={false}
                        value={listingCategory[1]}
                        onChange={(value) =>
                          handleChangeListingCategory(1, value)
                        }
                        required={false}
                      />
                      <TextArea
                        title=""
                        maxChars={50}
                        height="h-[50px]"
                        characterCount={true}
                        name="listingCategory3"
                        error={false}
                        value={listingCategory[2]}
                        onChange={(value) =>
                          handleChangeListingCategory(2, value)
                        }
                        required={false}
                      />
                      <TextArea
                        title=""
                        maxChars={50}
                        height="h-[50px]"
                        characterCount={true}
                        name="listingCategory4"
                        error={false}
                        value={listingCategory[3]}
                        onChange={(value) =>
                          handleChangeListingCategory(3, value)
                        }
                        required={false}
                      />
                    </div>
                  </div>
                </div>
              </section>
            )}
            {isMember && (
              <section className="formsectionNTitle">
                <CatalogSubTitle
                  title="Notables"
                  className="text-accent-Default-dark"
                />
                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4  w-full formsection flex-wrap md:flex-nowrap">
                  <div className="flex flex-col formsection w-full ">
                    <InputImageMinimal
                      setImage={setNotableImage1}
                      photo={notableImage1 as string}
                      title="Notable Image"
                    />

                    <Input
                      title="Notable URL"
                      name="notable1"
                      errorMsj={activeErrorsMessage.notable}
                      error={activeErrors.notable1}
                      value={formData?.notable1}
                      onChange={handleInputChange}
                      required={!!notableImage1}
                    />
                  </div>
                  <div className=" flex flex-col formsection w-full ">
                    <InputImageMinimal
                      setImage={setNotableImage2}
                      photo={notableImage2 as string}
                      title="Notable Image"
                    />

                    <Input
                      title="Notable URL"
                      name="notable2"
                      errorMsj={activeErrorsMessage.notable}
                      error={activeErrors.notable2}
                      value={formData?.notable2}
                      onChange={handleInputChange}
                      required={!!notableImage2}
                    />
                  </div>
                  <div className=" flex flex-col formsection w-full ">
                    <InputImageMinimal
                      setImage={setNotableImage3}
                      photo={notableImage3 as string}
                      title="Notable Image"
                    />
                    <Input
                      title="Notable URL"
                      name="notable3"
                      errorMsj={activeErrorsMessage.notable}
                      error={activeErrors.notable3}
                      value={formData?.notable3}
                      onChange={handleInputChange}
                      required={!!notableImage3}
                    />
                  </div>
                  <div className=" flex flex-col formsection w-full ">
                    <InputImageMinimal
                      setImage={setNotableImage4}
                      photo={notableImage4 as string}
                      title="Notable Image"
                    />
                    <Input
                      title="Notable URL"
                      name="notable4"
                      errorMsj={activeErrorsMessage.notable}
                      error={activeErrors.notable4}
                      value={formData?.notable4}
                      onChange={handleInputChange}
                      required={!!notableImage4}
                    />
                  </div>
                </div>
              </section>
            )}
            {isMember && (
              <section className="formsectionNTitle">
                <div className=" flex gap-2.5 w-full items-center">
                  <CatalogSubTitle
                    title="Firm Data"
                    className="text-accent-Default-dark"
                  />
                  <div className="flex items-center justify-center">
                    <NewTooltip text="This section reads data from the Database. It cannot be edited." />
                  </div>
                </div>
                <div className="flex flex-col formsection w-full">
                  <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 formsection">
                    <Input
                      title="Professionals in Primary"
                      name="professionalsInPrimary"
                      placeholder="0"
                      errorMsj={activeErrorsMessage.inputName}
                      error={false}
                      value={formData?.professionalsInPrimary?.toString()}
                      onChange={handleInputChange}
                    />
                    <Input
                      title="Professionals WorldWide"
                      name="professionalsWorldWide"
                      placeholder="0"
                      errorMsj={activeErrorsMessage.inputName}
                      error={false}
                      value={formData?.professionalsWorldWide?.toString()}
                      onChange={handleInputChange}
                    />
                    <Input
                      title="Total Professionals"
                      name="totalProfessionals"
                      placeholder="0"
                      errorMsj={activeErrorsMessage.inputName}
                      error={false}
                      value={formData?.totalProfessionals?.toString()}
                      onChange={handleInputChange}
                    />
                  </div>
                  <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 formsection">
                    <Input
                      title="Created Date"
                      name="dateCreated"
                      disabled={true}
                      errorMsj={""}
                      error={false}
                      value={formData?.dateCreated?.toString() ?? ""}
                      onChange={handleInputChange}
                    />
                    <Input
                      title="Joined Date"
                      name="dateJoined"
                      disabled={true}
                      placeholder={"DD/MM/YYYY"}
                      errorMsj={""}
                      error={false}
                      value={formData?.dateJoined?.toString() ?? ""}
                      onChange={handleInputChange}
                    />

                    <Input
                      title="Withdrawn Date"
                      name="dateWithdrawn"
                      disabled={true}
                      placeholder={"DD/MM/YYYY"}
                      errorMsj={""}
                      error={false}
                      value={formData?.dateWithdrawn?.toString() ?? ""}
                      onChange={handleInputChange}
                    />
                  </div>
                </div>
              </section>
            )}
            {!isContentRedirect && (
              <section className="formsectionNTitle">
                <CatalogSubTitle
                  title="Social Media"
                  className="text-accent-Default-dark"
                />
                <div className="w-full flex flex-col formsection">
                  <div className="flex flex-col md:flex-row w-full formsection">
                    <div className="flex flex-col w-full md:w-1/2 lg:w-1/2">
                      <Input
                        title="LinkedIn Public Profile URL"
                        name="linkedinUrl"
                        errorMsj={""}
                        error={false}
                        value={formData?.linkedinUrl}
                        onChange={handleInputChange}
                        required={false}
                        placeholder="ex: https://www.linkedin.com/in/username"
                      />
                    </div>
                    <div className="flex flex-col w-full md:w-1/2 lg:w-1/2 ">
                      <Input
                        title="X URL"
                        name="xUrl"
                        errorMsj={""}
                        error={false}
                        value={formData?.xUrl}
                        onChange={handleInputChange}
                        required={false}
                        placeholder="ex: https://www.twitter.com/username"
                      />
                    </div>
                  </div>
                  <div className="flex flex-col md:flex-row w-full formsection">
                    <div className="flex flex-col w-full md:w-1/2 lg:w-1/2">
                      <Input
                        title="Facebook Profile URL"
                        name="facebookUrl"
                        errorMsj={""}
                        error={false}
                        value={formData?.facebookUrl}
                        onChange={handleInputChange}
                        required={false}
                        placeholder="ex: https://www.facebook.com/yourname"
                      />
                    </div>
                    <div className="flex flex-col w-full md:w-1/2 lg:w-1/2 ">
                      <Input
                        title="Instagram Address URL"
                        name="instagramUrl"
                        errorMsj={""}
                        error={false}
                        value={formData?.instagramUrl}
                        onChange={handleInputChange}
                        required={false}
                        placeholder="ex: https://www.instagram.com/username"
                      />
                    </div>
                  </div>
                  <div className="flex flex-col md:flex-row w-full formsection">
                    <div className="flex flex-col w-full md:w-1/2 lg:w-1/2">
                      <Input
                        title="Youtube Profile URL"
                        name="youtubeUrl"
                        errorMsj={""}
                        error={false}
                        value={formData?.youtubeUrl}
                        onChange={handleInputChange}
                        required={false}
                        placeholder="ex: https://www.youtube.com/watch?v=VIDEO_ID"
                      />
                    </div>
                    <div className="flex flex-col w-full md:w-1/2 lg:w-1/2 ">
                      <Input
                        title="Other Social Media"
                        name="otherSocialMedia"
                        errorMsj={""}
                        error={false}
                        value={formData?.otherSocialMedia}
                        onChange={handleInputChange}
                        required={false}
                      />
                    </div>
                  </div>
                </div>
              </section>
            )}
            <ButtonsCrud
              Catalog="Firm"
              mode={props.mode}
              id={id ? id : ""}
              disabled={!canSave}
              actionButton={handleButtonClick}
              onDelete={handleDelete}
              state={state}
              newState={buildFirmObject()}
              customFieldNames={{
                ["phoneNumber.phone"]: "Phone Number",
              }}
            />
          </article>
        </form>
      </main>
    </>
  );
};
export default AddFirm;
